import { withStyles } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { Text } from "react-internationalization";
import TextField from "@material-ui/core/TextField";
import Snackbar from "@material-ui/core/Snackbar";
import Alert from "@material-ui/lab/Alert";
import * as DateUtil from "../../../Utils/DatePicker";
import { Styles } from "../../../assests/styles/DashboradStyles";
import AutoComplete1 from "../../../Utils/Select";
import Autocomplete2 from "../../../Utils/GenericUI/Select";
import DataTable from "../../../Utils/GenericUI/DataTable";

import { CampaignModalBulkHeader as CampaignSelectedFileHeader } from "../../../Utils/StaticData/DashboardHeader";

import { useSelector, useDispatch } from "react-redux";
import {
  ProspectManagementSaveProspect,
  getCampaignList,
  updateCampaignFilerecords,
  campaignFileTable,
  campaignFileData,
  getAgentList,
  loadCampaignOwnerNames,
} from "../../../Redux/Actions/webAppActions";
import moment from "moment";
import { handleDateChange } from "../../../Utils/DateFormatter";

//import SimpleReactValidator from "simple-react-validator";
import { CAMPAIGN_MANAGEMENT_INITIAL_STATE } from "../../../components/initialState";
import { connect } from "react-redux";
import { VERDA_CONSTS } from "../../../Utils/StaticData/Constant";

const SelectedFileTable = (props) => {
  const [bulkmodalrowsPerPage, setbulkmodalrowsPerPage] = React.useState(5);
  const [bulkmodalselectedRowIndex, setbulkmodalselectedRowIndex] =
    React.useState(0);
  const [Data, setData] = useState({ ...CAMPAIGN_MANAGEMENT_INITIAL_STATE });

  const [snackBarOpen, setsnackBarOpen] = useState(false);
  const [alertMsg, setalertMsg] = useState("");
  const [severity, setseverity] = useState("");
  const [vertical] = useState("top");
  const [horizontal] = useState("center");
  const [UpdatedList, setUpdatedList] = useState([]);
  //const defaultValue = { label: "select", value: "" };
  const associatedProduct = [
    { label: "WIPRO PREMIER ADVANTAGE ELITE PLUS", value: "0" },
    { label: "WIPRO PREMIER ADVANTAGE ELITE", value: "1" },
    { label: "WIPRO ESSENCE ADVANTAGE (HMO)", value: "2" },
    { label: "WIPRO ESSENCE ADVANTAGE PLUS (HMO)", value: "3" },
    { label: "PDP DIRECT ADVANTAGE", value: "4" },
  ];
  const associatedProductVerda = [
    { label: "VERDA NOBLE CARE (HMO)", value: "0" },
    { label: "VERDA NOBLE CHRONIC CARE (HMO-CSNP)", value: "1" },
  ];
  const campaignMedia = [
    { label: "TV", value: "0" },
    { label: "News Paper", value: "1" },
    { label: "Direct mail", value: "2" },
    { label: "Non-Campaign", value: "3" },
    { label: "workshop", value: "4" },
    { label: "Social Media", value: "5" },
  ];
  const status = [
    { label: "Open", value: "Open" },
    { label: "Hold", value: "Hold" },
    //{ label: "Closed", value: "Closed" },
  ];
  const customerId = useSelector((state1) => state1.login.customerId);
  const campaignRecords = useSelector(
    (state) => state.bulk.campaignBulkfilerecords
  );
  const isSuperUser = useSelector((state1) => state1.webApp.isSuperUser);
  // const prospectagentList = useSelector(
  //   (state1) => state1.campaignProspect.agentList
  // );
  const adminList = useSelector((state1) => state1.campaignProspect.adminList);
  const dispatch = useDispatch();
  useEffect(() => {
    setUpdatedList(campaignRecords);
  }, [campaignRecords]);
  useEffect(() => {
    dispatch(getAgentList(customerId));
    dispatch(loadCampaignOwnerNames());
  }, []);
  const rowSelectbulkModal = async (
    index1,
    selectedData,
    rowsPerPage2,
    type
  ) => {
    setbulkmodalrowsPerPage(rowsPerPage2);
    setbulkmodalselectedRowIndex(index1);
    //when new row selected initialising data as empty
    setData({ ...CAMPAIGN_MANAGEMENT_INITIAL_STATE });

    setData({ ...Data, ...selectedData });
  };
  const bulkModalhandleChangeRowsPerPage = async (rowsPerPage3) => {
    await setbulkmodalrowsPerPage(rowsPerPage3);
  };

  const handleChange = async (event) => {
    let name = event.target.name;
    let value = event.target.value;
    setData({ ...Data, [name]: value });
  };
  const handleMultipleSelectionDropdown = (name) => async (data1) => {
    let multipleValues = [];
    data1.forEach((data2) => {
      multipleValues.push(data2.value);
    });
    setData({ ...Data, [name]: multipleValues });
  };
  const handleDropdown = (name) => async (event) => {
    const value = event.target
      ? event.target.label
      : event.label || event.value;
    setData({ ...Data, [name]: value });
  };
  const handleOtherDropdown = (name) => async (event) => {
    const value = event.target
      ? event.target.value
      : event.value || event.label;
    setData({ ...Data, [name]: value });
  };
  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setsnackBarOpen(false);
  };
  const handleDates = (fieldId) => {
    DateUtil.getDatePicker("#" + fieldId).datepicker("show");
    DateUtil.getDatePicker("#" + fieldId).on("change", (e) => {
      setDates(fieldId, e.target.value);
    });
  };
  const setDates = async (fieldId, value) => {
    if (fieldId === "dob") {
      setData({ ...Data, [fieldId]: value, birthDate: value });
      return;
    }
    setData({ ...Data, [fieldId]: value });
  };
  const handleDate = async (event) => {
    let name = event.target.name;
    let value = event.target.value;
    value = handleDateChange(value);
    if (value === "") {
      setsnackBarOpen(true);
      setalertMsg("Please enter date in the MM/DD/YYYY format");
      setseverity("error");
    }
    if (name === "dob") {
      setData({ ...Data, [name]: value, birthDate: value });
      return;
    }
    setData({ ...Data, [name]: value });
  };
  const save = async (event) => {
    let list = ["Open", "Hold"];
    if (
      Data.planCampaignName === "" ||
      Data.planCampaignId === "" ||
      Data.campaignOwner === "" ||
      Data.campaignOwner === null ||
      Data.associatedProduct?.length < 1 ||
      Data.campaignMedia?.length < 1 ||
      Data.campaignStatus === "" ||
      (Data.campaignStatus && !list.includes(Data.campaignStatus)) ||
      Data.campaignStartDate === ""
    ) {
      setsnackBarOpen(true);
      setalertMsg("Please Enter All The Mandatory Fields!");
      setseverity("warning");
      return;
    } else {
      setData({ ...Data, saveCampaign: true });
      let CampaignPayload = UpdatedList;
      //checking whether already updated row data is updated and that is removed to avoid duplicate rows
      let filtered = {};

      if (CampaignPayload?.length > 0) {
        filtered = CampaignPayload.filter(
          (obj) => obj.identifier == Data?.identifier
        )[0];
        CampaignPayload = CampaignPayload.filter(
          (obj) => obj.identifier != Data?.identifier
        );
      }

      //current row values pushing
      CampaignPayload.push({ ...filtered, ...Data, saveCampaign: true });
      CampaignPayload.sort(function (a, b) {
        return a.identifier - b.identifier;
      });
      setsnackBarOpen(true);
      setalertMsg("Campaign is saved");
      setseverity("success");
      setUpdatedList(CampaignPayload);
      document.getElementById("campaignBulkUploadModal").style.display = "none";
      const collection1 = document.getElementsByClassName(
        "modal-backdrop show"
      );
      while (collection1.length > 0) {
        collection1[0].remove();
      }
    }
  };
  const Update = async (event) => {
    //list with campaign saved
    let UpdatedListFinal = UpdatedList.filter(
      (data) => data.saveCampaign === true
    );
    let recordsUpdatedNumber = UpdatedListFinal?.length;
    let campaignDataList = [];
    if (UpdatedListFinal?.length > 0) {
      for (const obj of UpdatedListFinal) {
        campaignDataList.push({
          uploadDetailId: obj?.uploadDetailId,
          planCampaignId: obj?.planCampaignId,
          planCampaignName: obj?.planCampaignName,
          associatedProduct: obj?.associatedProduct.toString(),
          campaignOwner: obj?.campaignOwner,
          campaignStatus: obj?.campaignStatus,
          campaignMedia: obj?.campaignMedia.toString(),
          contactPreference: "",
          campaignStartDate: obj?.campaignStartDate,
          campaignEndDate: obj?.campaignEndDate,
          campaignOwnerId: "",
        });
      }
      let Updatepayload = {
        uploadFileId: props?.SelectedFileId,
        customerId: customerId,
        campaignDataList: campaignDataList,
        status: props?.selectedFilestatus,
      };
      let response = dispatch(updateCampaignFilerecords(Updatepayload));
      response.then(function (value) {
        if (value?.status === "OK") {
          setsnackBarOpen(true);
          setalertMsg(`Records updated:${recordsUpdatedNumber}`);
          setseverity("success");
          dispatch(
            campaignFileData({
              fileId: props?.SelectedFileId,
              status: props?.selectedFilestatus,
            })
          );
          dispatch(campaignFileTable());
        } else {
          setsnackBarOpen(true);
          setalertMsg("Failed to update");
          setseverity("warning");
        }
      });
    } else {
      setsnackBarOpen(true);
      setalertMsg("Please update campaign records");
      setseverity("warning");
    }
  };
  // const formatPhoneNumber = (phoneNumberString) => {
  //   var match = phoneNumberString.match(/^(\d{3})(\d{3})(\d{4})$/);
  //   if (match) {
  //     return "(" + match[1] + ") " + match[2] + "-" + match[3];
  //   }
  //   return phoneNumberString;
  // };
  //const validator = new SimpleReactValidator();
  return (
    <React.Fragment>
      <Snackbar
        open={snackBarOpen}
        autoHideDuration={3000}
        onClose={handleClose}
        anchorOrigin={{ vertical, horizontal }}
        key={vertical + horizontal}
      >
        <Alert onClose={handleClose} severity={severity}>
          {alertMsg}
        </Alert>
      </Snackbar>
      <div class="container-campaignmain prospecttablealign mt-3 mb-3">
        <div class="d-flex justify-content-end">
          <button
            class="btn btn-dashboard-active ml-5 hcampaign btn-dashboard-active-color "
            onClick={props?.goBack}
          >
            <Text id="plan.goback" />
          </button>
          <button
            class="btn btn-dashboard-active ml-5 hcampaign btn-dashboard-active-color "
            onClick={Update}
          >
            <Text id="app.update" />
          </button>
        </div>
        <div class="ml-3">
          <div class="row">
            <p class="text-nowrap">
              <Text id="app.filename" />
              :&nbsp;
              <strong>{props?.selectedFile}</strong>
            </p>
          </div>
          <div class="row">
            <p>
              <Text id="app.status" />
              :&nbsp;
              <strong>{props?.selectedFilestatus}</strong>
            </p>
          </div>
        </div>
        {/* datatable */}
        <div class="pt-1" style={{ overflow: "auto" }}>
          <DataTable
            modalSelect={"#campaignBulkUploadModal"}
            width="100%"
            padding="4px 45px 4px 8px"
            paddingRight="50px"
            dashboard="BulkUploadSelectedFileData"
            rowsPerPage={bulkmodalrowsPerPage}
            rowsPerPageOptions={[5, 10, 15]}
            handleChangeRowsPerPage={bulkModalhandleChangeRowsPerPage}
            clicked={rowSelectbulkModal}
            //columnSelected={columnSelected}
            setClick={(x) => {}}
            index={bulkmodalselectedRowIndex}
            sortable={true}
            searchable={true}
            header={CampaignSelectedFileHeader}
            rowcount={props?.rowcount}
            //data={props?.newAddUsers}
            data={UpdatedList}
            exportAsExcel={true}
            // clickedFirst={this.prospectrowSelectFirst}
          />
        </div>
        {/* popup */}
        <div
          id="campaignBulkUploadModal"
          class="modal fade z-index-1051"
          data-keyboard="false"
          data-backdrop="static"
          // className="tabs-container w-106 mt-3"
        >
          <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable ">
            <div class="modal-content">
              <div class="modal-header">
                <h4 class="modal-title">Campaign Details</h4>
                <button type="button" class="close" data-dismiss="modal">
                  &times;
                </button>
              </div>
              <div class="modal-body">
                <div className="panel-body campaignsingle">
                  <div className="form-panel2">
                    {/* row1 */}
                    <div className="row">
                      {/* <div className="col-md-12"> */}
                      <span className="col-lg-4 col-md-6 col-sm-12 mb-2">
                        <span className="label-container">
                          <label
                            className="labelcampaign"
                            for="planCampaignName"
                          >
                            Campaign Name*
                          </label>
                          <br />

                          <TextField
                            name="planCampaignName"
                            error={Data?.planCampaignName === "" ? true : false}
                            value={Data?.planCampaignName}
                            size="small"
                            className="prospectwidth9"
                            onChange={handleChange}
                            inputProps={{
                              maxLength: 20,
                              autoComplete: "off",
                              spellcheck: "false",
                              "aria-autocomplete": "both",
                              "aria-haspopup": "false",
                            }}
                            variant="outlined"
                          />
                        </span>
                      </span>
                      <span className="col-lg-4 col-md-6 col-sm-12 mb-2">
                        <span className="label-container">
                          <label className="labelcampaign" for="planCampaignId">
                            Plan Campaign ID*
                          </label>
                          <br />

                          <TextField
                            name="planCampaignId"
                            size="small"
                            className="prospectwidth9"
                            error={Data?.planCampaignId === "" ? true : false}
                            value={Data?.planCampaignId}
                            inputProps={{
                              maxLength: 20,
                              autoComplete: "off",
                              spellcheck: "false",
                              "aria-autocomplete": "both",
                              "aria-haspopup": "false",
                            }}
                            onChange={handleChange}
                            variant="outlined"
                          />
                        </span>
                      </span>
                      <span className="col-lg-4 col-md-6 col-sm-12 mb-2 campaignOwner">
                        <label className="labelcampaign" for="campaignOwner">
                          Campaign owner*
                        </label>
                        <br />
                        {isSuperUser === true ? (
                          <>
                            <Autocomplete2
                              error={
                                customerId === VERDA_CONSTS.ID
                                  ? adminList.some(
                                      (x) => x.label === Data?.campaignOwner
                                    )
                                    ? false
                                    : true
                                  : props.campaignOwnerNamesList.some(
                                      (x) => x.label === Data?.campaignOwner
                                    )
                                  ? false
                                  : true
                              }
                              handleChange={handleDropdown("campaignOwner")}
                              options={
                                customerId === VERDA_CONSTS.ID
                                  ? adminList
                                  : props.campaignOwnerNamesList
                              }
                              value={
                                customerId === VERDA_CONSTS.ID
                                  ? adminList?.length > 1 &&
                                    adminList.filter(
                                      (data1) =>
                                        data1.label === Data?.campaignOwner
                                    )[0] !== undefined
                                    ? adminList.filter(
                                        (data1) =>
                                          data1.label === Data?.campaignOwner
                                      )[0]
                                    : { label: "", value: "" }
                                  : props.campaignOwnerNamesList?.length > 1 &&
                                    props.campaignOwnerNamesList.filter(
                                      (data1) =>
                                        data1.label === Data?.campaignOwner
                                    )[0] !== undefined
                                  ? props.campaignOwnerNamesList.filter(
                                      (data1) =>
                                        data1.label === Data?.campaignOwner
                                    )[0]
                                  : { label: "", value: "" }
                              }
                              width="100%"
                              show={true}
                            />
                          </>
                        ) : (
                          <TextField
                            name="campaignOwner"
                            error={Data?.campaignOwner === "" ? true : false}
                            size="small"
                            className="prospectwidth9"
                            value={Data?.campaignOwner}
                            inputProps={{
                              maxLength: 40,
                              autoComplete: "off",
                              spellcheck: "false",
                              "aria-autocomplete": "both",
                              "aria-haspopup": "false",
                            }}
                            onChange={handleChange}
                            variant="outlined"
                          />
                        )}
                      </span>
                    </div>

                    <div className="row">
                      <div className="col-md-12">
                        <span className="label-container">
                          <AutoComplete1
                            label="Associated product *"
                            multiple={true}
                            dashboard="campaign"
                            height="7px !important"
                            field="associated"
                            width="360px"
                            handleChange={handleMultipleSelectionDropdown(
                              "associatedProduct"
                            )}
                            options={
                              customerId === VERDA_CONSTS.ID
                                ? associatedProductVerda
                                : associatedProduct
                            }
                            value={
                              customerId === VERDA_CONSTS.ID
                                ? associatedProductVerda.filter(
                                    (data2) =>
                                      Data?.associatedProduct.indexOf(
                                        data2.value
                                      ) !== -1
                                  )
                                : associatedProduct.filter(
                                    (data1) =>
                                      Data?.associatedProduct.indexOf(
                                        data1.value
                                      ) !== -1
                                  )
                            }
                            //defaultValue={defaultassociatedProduct}
                            name="associatedProduct"
                            error={
                              Data?.associatedProduct?.length < 1 ? true : false
                            }
                            style={{ border: "0.5px solid rgb(205, 14, 14)" }}
                          />
                        </span>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-12">
                        <span className="label-container">
                          <AutoComplete1
                            label="Campaign Media *"
                            dashboard="campaign"
                            height="7px !important"
                            width="236px"
                            multiple={true}
                            handleChange={handleMultipleSelectionDropdown(
                              "campaignMedia"
                            )}
                            options={campaignMedia}
                            value={campaignMedia.filter(
                              (data1) =>
                                Data?.campaignMedia.indexOf(data1.value) !== -1
                            )}
                            name="campaignMedia"
                            error={
                              Data?.campaignMedia?.length < 1 ? true : false
                            }
                          />
                        </span>
                        <span className="label-container">
                          <AutoComplete1
                            label="Status *"
                            dashboard="campaign"
                            height="7px !important"
                            width="236px"
                            error={
                              Data?.campaignStatus === "" ||
                              (Data?.campaignStatus &&
                                !["Open", "Hold"].includes(Data.campaignStatus))
                                ? true
                                : false
                            }
                            handleChange={handleOtherDropdown("campaignStatus")}
                            options={status}
                            value={
                              status.filter(
                                (data1) => data1.value === Data?.campaignStatus
                              ).length !== 0
                                ? status.filter(
                                    (data1) =>
                                      data1.value === Data?.campaignStatus
                                  )[0]
                                : {
                                    label: "select",
                                    value: "",
                                  }
                            }
                            name="status"
                          />
                        </span>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-12">
                        <span className="label-container setTop">
                          <label
                            className="labelcampaign"
                            for="campaignStartDate"
                          >
                            Start Date*
                          </label>
                          <input
                            autoComplete="off"
                            spellcheck="false"
                            aria-autocomplete="both"
                            aria-haspopup="false"
                            type="text"
                            className={
                              Data?.campaignStartDate === "" ||
                              !moment(
                                Data?.campaignStartDate,
                                "MM/DD/YYYY",
                                true
                              ).isValid()
                                ? "error-inputdashboard1 scrollfix"
                                : "form-control2dashboard scrollfix"
                            }
                            id="campaignStartDate"
                            placeholder="MM/DD/YYYY"
                            name="campaignStartDate"
                            value={Data?.campaignStartDate}
                            onChange={handleDate}
                            onClick={(e) => handleDates("campaignStartDate")}
                          />
                        </span>

                        <span className="label-container setTop">
                          <label
                            className="labelcampaign"
                            for="campaignEndDate"
                          >
                            End Date
                          </label>
                          <input
                            autoComplete="off"
                            spellcheck="false"
                            aria-autocomplete="both"
                            aria-haspopup="false"
                            type="text"
                            className={"form-control2dashboard scrollfix"}
                            id="campaignEndDate"
                            placeholder="MM/DD/YYYY"
                            name="campaignEndDate"
                            value={Data?.campaignEndDate}
                            onChange={handleDate}
                            onClick={(e) => handleDates("campaignEndDate")}
                          />
                        </span>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-12">
                        <span className="label-container">
                          <label className="labelcampaign" for="enrlCampaignId">
                            e-Enroll Campaign ID
                          </label>
                          <br />
                          <TextField
                            disabled
                            name="enrlCampaignId"
                            // value={this.state.enrlCampaignId}
                            size="small"
                            className="prospectwidth9 prospectDark-text"
                            onChange={handleChange}
                            variant="outlined"
                            autoComplete="off"
                          />
                        </span>
                        <span className="label-container">
                          <label className="labelcampaign" for="createdTime">
                            Create Time
                          </label>
                          <br />
                          <TextField
                            name="createdTime"
                            size="small"
                            //value={this.state.createdTime}
                            disabled
                            className="prospectwidth9 prospectDark-text"
                            onChange={handleChange}
                            variant="outlined"
                            autoComplete="off"
                          />
                        </span>
                        <span className="label-container">
                          <label className="labelcampaign" for="createdBy">
                            Create User
                          </label>
                          <br />
                          <TextField
                            name="createdBy"
                            size="small"
                            //value={this.state.createdBy}
                            disabled
                            className="prospectwidth9 prospectDark-text"
                            onChange={handleChange}
                            variant="outlined"
                            autoComplete="off"
                          />
                        </span>
                        <span className="label-container">
                          <label className="labelcampaign" for="lastUpdate">
                            Modified Time
                          </label>
                          <br />
                          <TextField
                            name="lastUpdate"
                            size="small"
                            //value={this.state.lastUpdate}
                            disabled
                            className="prospectwidth9 prospectDark-text"
                            onChange={handleChange}
                            variant="outlined"
                            autoComplete="off"
                          />
                        </span>
                        <span className="label-container">
                          <label className="labelcampaign" for="lastUpdateUser">
                            Modified User
                          </label>
                          <br />
                          <TextField
                            name="lastUpdateUser"
                            size="small"
                            // value={this.state.lastUpdateUser}
                            disabled
                            className="prospectwidth9 prospectDark-text"
                            onChange={handleChange}
                            variant="outlined"
                            autoComplete="off"
                          />
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="modal-footer">
                <button
                  id="submit"
                  onClick={save}
                  class="btn btn-dashboard-active"
                >
                  {" "}
                  Save{" "}
                </button>
                <button class="btn btn-campaign" data-dismiss="modal">
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};
const mapStateToProps = (state) => {
  return {
    customerId: state.login.customerId,
    prospectagentList: state.campaignProspect.agentList,
    adminList: state.campaignProspect.adminList,
    campaignNames: state.campaignProspect.campaignNamesList,
    zipCodes: state.webApp.zipCodes,
    campaignOwnerNamesList: state.campaignProspect.campaignOwnerNamesList,
  };
};
const mapDispatchToProps = {
  ProspectManagementSaveProspect,
  getCampaignList,
  loadCampaignOwnerNames,
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(Styles)(SelectedFileTable));
